import React, { useState } from "react";
import { Grid2 } from "@mui/material";
import styles from "./SelfMigrate.module.scss";
import ExpandableRow from "../../../../../../../../GlobalComponents/ExpandableRow/ExpandableRow";
import InstallPlugin from "../../../../../../AdminAssets/png/installPlugin.png";
import MigrationKey from "../../../../../../AdminAssets/png/migrationKey.png";
import SftpProcess from "../../../../../../AdminAssets/png/sftpProcess.png";
import OtherHost from "../../../../../../AdminAssets/png/otherHost.png";

const SelfMigrate = () => {
  const [expandedRow, setExpandedRow] = useState("1");

  return (
    <Grid2 className={styles.selfMigrateContainer}>
      <ExpandableRow
        sno="1"
        header="Install the Migrate Guru Plugin"
        steps={[
          {
            title:
              "Begin by installing and activating the Migrate Guru plugin on both the source site and the destination site (your Rocon-hosted site).",
            image: <img src={InstallPlugin} className={styles.imgContainer} />,
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="2"
        header="Generate the Migration Key from Rocon"
        steps={[
          {
            title: "On your Rocon site, go to the WordPress Admin Dashboard.",
          },
          { title: "Navigate to Migrate Guru." },
          {
            title:
              "Expand the Migration Key section and click Copy to save the key to your clipboard.",
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="3"
        header="Initiate Migration from the Source Site"
        steps={[
          {
            title: "On your source WordPress site, access the Admin Dashboard.",
          },
          { title: "Navigate to Migrate Guru." },
          {
            title:
              "Enter your email address, agree to the terms by selecting the checkbox, and click Migrate to proceed.",
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="4"
        header="Choose hosting type"
        steps={[
          {
            title:
              "On the migration setup screen, select “Other Hosts” to proceed with a custom migration setup.",
            image: <img src={OtherHost} className={styles.imgContainer} />,
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="5"
        header="Select a Migration Method"
        subHeader={"Migrate Guru offers two ways to complete the migration:"}
        steps={[
          {
            title: "Using a Migration Key",
            subSteps: [
              {
                text: "Paste the previously copied Migration Key from your Rocon site.",
              },
              {
                text: "Enter the required credentials for both the source and destination sites as prompted.",
              },
              {
                text: "Click Migrate to start the migration process.",
              },
            ],
            image: <img src={MigrationKey} className={styles.imgContainer} />,
          },
          {
            title: "Using SFTP Credentials",
            subSteps: [
              {
                text: "Click on “Manually Input Host Details”.",
              },
              {
                text: `Enter the following details for the destination (Rocon) site: Site URL, IP Address, FTP Username, FTP Password, Directory Path.`,
              },
              {
                text: "The directory path should be in the format website-name/ . For example, if your site name is johndoe, the directory path should be johndoe/",
              },
              {
                text: "Once all required information is provided, click Migrate to begin the process.",
              },
            ],
            image: <img src={SftpProcess} className={styles.imgContainer} />,
          },
          {
            title:
              "That’s it! Migrate Guru will now handle the entire process automatically, including data transfer and configuration syncing. You'll receive an email notification once the migration is complete.",
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
    </Grid2>
  );
};

export default SelfMigrate;
